import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import 'moment/locale/en-gb';

import { en } from './locales/locales';

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: process.env.REACT_APP_DEBUG === 'true',
        lng: 'en',
        fallbackLng: 'en',
        resources: {
            en: {
                skeleton: en.en,
            },
        },
        ns: ['skeleton'],
        defaultNS: 'skeleton',
        interpolation: {
            escapeValue: false,
        },
        react: {
            wait: false,
            bindI18n: 'languageChanged loaded',
            bindStore: 'added removed',
            nsMode: 'default',
        },
    });

export default i18n;
